import { convertSimNaoEnumToBoolean } from '@mchat-rf/consulta-seguimento/converter-consultaSeguimento'
import { MChatPerguntaEnum, MChatPerguntaOpcaoEnum, MChatRfPerguntaRespostaInput } from 'graphql/types.generated'
import { isUndefinedOrNull } from 'util/checks'

import {
  ConsultaSeguimentoPergunta07ApontaPorEnum,
  ConsultaSeguimentoPergunta07Model,
} from './model-consultaSeguimentoPergunta07'

const consultaSeguimentoPergunta07ToPerguntaOpcao: Record<
  ConsultaSeguimentoPergunta07ApontaPorEnum,
  MChatPerguntaOpcaoEnum
> = {
  AJUDA: MChatPerguntaOpcaoEnum.AJUDA,
  INTERESSE: MChatPerguntaOpcaoEnum.INTERESSE,
}

export const convertConsultaSeguimentoPergunta07ToInput = (
  value: ConsultaSeguimentoPergunta07Model
): Array<MChatRfPerguntaRespostaInput> => {
  const caminho: MChatRfPerguntaRespostaInput[] = [
    {
      pergunta: MChatPerguntaEnum.PERGUNTA_07_01,
      stResposta: convertSimNaoEnumToBoolean(value.PERGUNTA_07_HEADER),
    },
    {
      pergunta: MChatPerguntaEnum.PERGUNTA_07_02,
      stResposta: convertSimNaoEnumToBoolean(value.PERGUNTA_07_OLHAR_PARA?.AVIAO),
    },
    {
      pergunta: MChatPerguntaEnum.PERGUNTA_07_03,
      stResposta: convertSimNaoEnumToBoolean(value.PERGUNTA_07_OLHAR_PARA?.CAMINHAO),
    },
    {
      pergunta: MChatPerguntaEnum.PERGUNTA_07_04,
      stResposta: convertSimNaoEnumToBoolean(value.PERGUNTA_07_OLHAR_PARA?.BICHO),
    },
    {
      pergunta: MChatPerguntaEnum.PERGUNTA_07_05,
      stResposta: convertSimNaoEnumToBoolean(value.PERGUNTA_07_OLHAR_PARA?.ANIMAL),
    },
    {
      pergunta: MChatPerguntaEnum.PERGUNTA_07_06,
      stResposta: convertSimNaoEnumToBoolean(value.PERGUNTA_07_APONTA_COM_DEDO),
    },
    {
      pergunta: MChatPerguntaEnum.PERGUNTA_07_07,
      perguntaOpcao: value.PERGUNTA_07_APONTA_POR
        ? consultaSeguimentoPergunta07ToPerguntaOpcao[value.PERGUNTA_07_APONTA_POR]
        : undefined,
    },
  ]

  return caminho.filter((item) => !isUndefinedOrNull(item.perguntaOpcao) || !isUndefinedOrNull(item.stResposta))
}
